export interface AuthTab {
  id: string;
  name: string;
  description: string;
  route: string;
  icon: string;
  enabled: boolean;
}

export interface AuthConfig {
  id: string;
  name: string;
  description: string;
  authProvider: 'main' | 'intake';
  tabs: AuthTab[];
  defaultRoute: string;
  protectedRoutes: string[];
}

export const authConfigurations: AuthConfig[] = [
  {
    id: 'full-access',
    name: 'Full Access Portal',
    description: 'Access to both Research Tool and Intake Tool',
    authProvider: 'main',
    tabs: [
      {
        id: 'research-tool',
        name: 'Research Tool',
        description: 'Access to research and analysis tools',
        route: '/member',
        icon: 'ContentPasteSearch',
        enabled: true
      },
      {
        id: 'intake-tool',
        name: 'Intake Tool',
        description: 'Access to intake and data collection tools',
        route: '/intake',
        icon: 'Rocket',
        enabled: true
      }
    ],
    defaultRoute: '/',
    protectedRoutes: ['/member', '/intake', '/']
  },
  {
    id: 'intake-only',
    name: 'Intake Portal',
    description: 'Access to Intake Tool only',
    authProvider: 'intake',
    tabs: [
      {
        id: 'intake-tool',
        name: 'Intake Tool',
        description: 'Access to intake and data collection tools',
        route: '/intake',
        icon: 'Rocket',
        enabled: true
      }
    ],
    defaultRoute: '/intake',
    protectedRoutes: ['/intake']
  }
];

// Helper function to get auth config by user role or other criteria
export const getAuthConfigByRole = (userRole?: string): AuthConfig => {
  // You can implement role-based logic here
  // For now, returning full access as default
  if (userRole === 'intake') {
    return authConfigurations[1]; // intake-only
  }
  return authConfigurations[0]; // full-access
};

// Helper function to get auth config by ID
export const getAuthConfigById = (id: string): AuthConfig | undefined => {
  return authConfigurations.find(config => config.id === id);
};

// Helper function to check if a route is protected for a given config
export const isRouteProtected = (route: string, configId: string): boolean => {
  const config = getAuthConfigById(configId);
  if (!config) return false;
  
  return config.protectedRoutes.some(protectedRoute => 
    route.startsWith(protectedRoute)
  );
};

// Helper function to get available tabs for a user
export const getAvailableTabs = (configId: string): AuthTab[] => {
  const config = getAuthConfigById(configId);
  if (!config) return [];
  
  return config.tabs.filter(tab => tab.enabled);
};